"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shopbyConfig = void 0;
exports.shopbyConfig = function (axios) {
    return {
        getShopbyConfigExternalServiceConfigurations: function (request) {
            return axios.get('/shopby-config/external-service/configurations', request);
        },
        patchShopbyConfigExternalServiceConfigurations: function (request) {
            return axios.patch('/shopby-config/external-service/configurations', request.data);
        }
    };
};
